export const LINK_LIFETIME_MS = 30_000;

export const QR_SIZE = 220;
export const QR_CARD_PADDING = 16;
export const QR_CARD_SIZE = QR_SIZE + QR_CARD_PADDING * 2;

export const RING_SIZE = 34;
export const RING_RADIUS = 14;
export const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

export const fade = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
  transition: { duration: 0.22, ease: 'easeOut' },
};
